import React, { useMemo } from "react";
import Grid from "@material-ui/core/Grid";
import * as Dati from "../../../Dati";
import * as DatiFide from "../../../DatiFide";
import * as Compat from "../../../Compat";
import { Trad } from "../../../components";
import { _Autocomplete, _DateField, _NumberField, _Select } from "../../form";
import { _ButtonAPI } from "..";

interface IChangeStatusButtonsProps {
    CurrentStatus: string;
    Statuses: Dati.TDictTipo;
    GetFormData: (newStatus: string) => void;
    OnChangeState: (data: DatiFide.CRisAPIDatoTipi_FideAffidamento) => void;
    OnApiError: (error: Error) => void;
}

export const _ChangeStatusButtons: React.FC<IChangeStatusButtonsProps> = ({ CurrentStatus, Statuses, GetFormData, OnChangeState, OnApiError }) => {
    const dictTipoToAny = (data: Dati.TDictTipo): Dati.CTipo[] => {
        let Values: any[] = [];
        for (let key in data) {
            Values.push({
                ID_Chiave: data[key].ID_Chiave,
                Valore: data[key].Valore,
                Permesso: data[key].Permesso
            });
        }

        return Values;
    };

    const getPermittedStatuses = (statuses: Dati.CTipo[]): Dati.CTipo[] => {
        let permittedStatuses: Dati.CTipo[] = [];

        for (let status in statuses) {
            if (!statuses[status].Permesso || ((statuses[status].Permesso || []).indexOf(CurrentStatus) >= 0 && statuses[status].ID_Chiave != CurrentStatus)) {
                permittedStatuses.push(Compat.ES6_Object_assign(statuses[status]));
            }
        }

        return permittedStatuses;
    };

    const permittedStatuses = useMemo(() => getPermittedStatuses(dictTipoToAny(Statuses)), [Statuses, CurrentStatus]);

    return (
        <>
            {permittedStatuses.map(status => (
                <Grid item key={status.ID_Chiave}>
                    <_ButtonAPI
                        Attivo
                        Testo={`${Trad.Trad("Passa a: ")} ${Trad.Trad(status.Valore)}`}
                        URL="/api/fideaffidamento/"
                        OnInvio={() => GetFormData(status.ID_Chiave)}
                        OnClick={OnChangeState}
                        OnErrore={OnApiError}
                    />
                </Grid>
            ))}
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/ExposureLimit/ChangeStatusButtons.tsx